import type { ReactNode } from 'react';
import { resolveImagePath } from '@/utils/imageMap';

interface CTASectionProps {
  className?: string;
}

export function CTASection({ className = '' }: CTASectionProps): ReactNode {
  const cityImageUrl = resolveImagePath('/images/louisville-skyline.png');

  return (
    <section 
      className={`relative overflow-hidden pt-16 lg:py-24 md:pb-16 ${className}`}
      style={{ backgroundColor: '#0c71c3' }}
    >
      {/* Fixed City Image - Right Side - 2/3 width */}
      <div className="absolute inset-y-0 right-0 w-2/3 hidden md:block">
        <div 
          className="w-full h-full bg-cover bg-center bg-fixed"
          style={{ backgroundImage: `url('${cityImageUrl}')` }}
          aria-label="Louisville city skyline"
        />
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          {/* Left Column - Text Content - 1/3 width */}
          <div className="text-left md:pr-8 md:col-span-1">
            {/* Main Headline */}
            <h2 
              className="text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight"
              style={{ fontFamily: '"Open Sans", Arial, sans-serif', fontWeight: 500 }}
            >
              Your Gateway to Louisville,KY
            </h2>
            
            {/* Description */}
            <p 
              className="text-lg text-white leading-relaxed mb-8"
              style={{ fontFamily: '"Open Sans", Arial, sans-serif', fontWeight: 500 }}
            >
              Located just 10 minutes north of Louisville, we're the ideal alternate to KSDF and other area airports.
            </p>
            
            {/* Call to Action Button */}
            <div className="flex justify-start">
              <a
                href="https://www.gotolouisville.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-transparent hover:bg-white hover:text-blue-600 transition-colors duration-200 rounded-md border-2 border-white"
                style={{ 
                  fontFamily: '"Open Sans", Arial, sans-serif',
                  fontWeight: 500,
                  color: '#ffffff'
                }}
              >
                Explore Louisville
              </a>
            </div>
          </div>
          
          {/* Right Column - Mobile City Image - Full width, no padding */}
          <div className="md:hidden -mx-4 sm:-mx-6">
            <img 
              src={cityImageUrl} 
              alt="Louisville city skyline"
              className="w-full h-64 object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}